<section class="flex flex-col overflow-hidden">
  <section class="flex items-center justify-between p-20 border-b border-gray-200">
    <h1 class="text-lg font-bold">Reminder</h1>
    <button type="button" mat-dialog-close mat-button class="icon-button is-primary is-inverted" (click)="closeDialog()">
      <span class="material-icons mi-18">close</span>
    </button>
  </section>
  <section class="flex flex-col flex-grow overflow-auto border-b border-gray-200 p-30">
    <div class="flex flex-col gap-20 m-auto">
      <span class="flex w-48 h-48 mx-auto bg-orange-100 rounded-full">
        <span class="m-auto text-orange-500 material-icons">warning</span>
      </span>
      <p class="mx-auto text-lg text-center max-w-400">Your E&O policy will expire in {{data.days}} days on {{data.date | date}}. Click on the link below for group priced FIG E&O.</p>
    </div>
  </section>
  <section class="flex justify-end flex-none p-20">
    <button type="button" mat-button class="button is-primary" (click)="getQuotes()">
      <span class="flex items-center gap-5">
        <span>Get a Quote</span>
        <span class="material-icons mi-18">chevron_right</span>
      </span>
    </button>
  </section>
</section>